/**
 * 储值卡订单列表
 */
import Vue from 'vue';
import _ from 'lodash';
import {
    GET_PREPAID_RECORD_LIST_REQUEST,
    GET_PREPAID_RECORD_LIST_SUCCESS,
    GET_PREPAID_RECORD_LIST_FAILURE,
    UPDATE_GET_PREPAID_PAGE_CONFIG,
    GET_PRE_PAID_ORDER_FIX_RECORD,
    UPDATE_GET_PREPAID_MOBILE_CONFIG,
    UPDATE_GET_PREPAID_PARAMS_CONFIG,
    RESET_PRE_PAID_RECORD_STATE
} from '../mutationTypes';

const state = {
    listLoading: false,
    list: [],
    page: 1,
    mobile: '',
    pagesize: 10,
    pageCount: 1,
    fixedRecord: [],
    reqParams: {},
};

const mutations = {
    [GET_PREPAID_RECORD_LIST_REQUEST](state) {
        state.listLoading = true;
    },
    [GET_PREPAID_RECORD_LIST_SUCCESS](state, res) {
        state.listLoading = false;

        state.list = res.list;
        state.pageCount = res.page_count;
    },
    [GET_PREPAID_RECORD_LIST_FAILURE](state) {
        state.listLoading = false;
    },
    [UPDATE_GET_PREPAID_PAGE_CONFIG](state, page) {
        state.page = page;
        state.reqParams.page = page;
    },
    [GET_PRE_PAID_ORDER_FIX_RECORD](state, res) {
        state.fixedRecord = res;
    },
    [UPDATE_GET_PREPAID_MOBILE_CONFIG](state, mobile) {
        state.mobile = mobile;
    },
    [UPDATE_GET_PREPAID_PARAMS_CONFIG](state, params) {
        state.reqParams = params;
    },
    [RESET_PRE_PAID_RECORD_STATE](state) {
        _.extend(state, _.cloneDeep({
            listLoading: false,
            list: [],
            page: 1,
            mobile: '',
            pagesize: 10,
            pageCount: 1,
            fixedRecord: [],
            reqParams: {},
        }));
    }
};

export const actions = {
    async getPrePaidOrderList({ commit }) {
        commit(GET_PREPAID_RECORD_LIST_REQUEST);


        const res = await Vue.$ajax.get('chargeOrderList', state.reqParams);

        if (!res.errorType) {
            commit(GET_PREPAID_RECORD_LIST_SUCCESS, res);
        } else {
            commit(GET_PREPAID_RECORD_LIST_FAILURE);
        }
    },
    async getPrePaidFixedRecord({ commit }, orderId) {
        const res = await Vue.$ajax.get('correctChargeRecord', {
            order_id: orderId,
        });

        if (!res.errorType) {
            commit(GET_PRE_PAID_ORDER_FIX_RECORD, res); // no error
            return res;
        }
        commit(GET_PRE_PAID_ORDER_FIX_RECORD, []);
        return [];
    },
    resolvePrePaidRecordParams({ commit }) {
        const params = {
            page: state.page,
            pagesize: state.pagesize,
            mobile: state.mobile,
        };

        commit(UPDATE_GET_PREPAID_PARAMS_CONFIG, params);
    },
    resetPrePaidRecord({ commit }) {
        commit(RESET_PRE_PAID_RECORD_STATE);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/prePaidRecord.js